import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WizardService {

  /*
  requestId
  requestObservations
  editable
  fromSupplier
  comparatorType
  electricComparatorResult
  gasComparatorResult
  clientId
  clientTypePF
  clientTypePJ
  placeId
  taskId
  placeElectricity
  placeGas
  supplierId
  contractNumber
   */

  constructor() { }

  public setWizardInformation(values: any): void {
    localStorage.removeItem('signedDocumentUUID');

    if (values.requestId) {
      localStorage.setItem('requestId', values.requestId);
    } else {
      localStorage.removeItem('requestId');
    }
    if (values.taskId) {
      localStorage.setItem('taskId', values.taskId);
    } else {
      localStorage.removeItem('taskId');
    }
    if (values.requestObservations) {
      localStorage.setItem('requestObservations', values.requestObservations);
    } else {
      localStorage.removeItem('requestObservations');
    }
    if (values.editable) {
      localStorage.setItem('editable', values.editable);
    } else {
      localStorage.removeItem('editable');
    }
    if (values.fromSupplier) {
      localStorage.setItem('fromSupplier', values.fromSupplier);
    } else {
      localStorage.removeItem('fromSupplier');
    }
    if (values.comparatorType) {
      localStorage.setItem('comparatorType', values.comparatorType);
    } else {
      localStorage.removeItem('comparatorType');
    }
    if (values.electricComparatorResult) {
      localStorage.setItem('electricComparatorResult', values.electricComparatorResult);
    } else {
      localStorage.removeItem('electricComparatorResult');
    }
    if (values.gasComparatorResult) {
      localStorage.setItem('gasComparatorResult', values.gasComparatorResult);
    } else {
      localStorage.removeItem('gasComparatorResult');
    }
    if (values.clientId) {
      localStorage.setItem('clientId', values.clientId);
    } else {
      localStorage.removeItem('clientId');
    }
    if (values.clientTypePF) {
      localStorage.setItem('clientTypePF', values.clientTypePF);
    } else {
      localStorage.removeItem('clientTypePF');
    }
    if (values.clientTypePJ) {
      localStorage.setItem('clientTypePJ', values.clientTypePJ);
    } else {
      localStorage.removeItem('clientTypePJ');
    }
    if (values.placeId) {
      localStorage.setItem('placeId', values.placeId);
    } else {
      localStorage.removeItem('placeId');
    }
    if (values.placeElectricity) {
      localStorage.setItem('placeElectricity', values.placeElectricity);
    } else {
      localStorage.removeItem('placeElectricity');
    }
    if (values.placeGas) {
      localStorage.setItem('placeGas', values.placeGas);
    } else {
      localStorage.removeItem('placeGas');
    }
    if (values.supplierId) {
      localStorage.setItem('supplierId', values.supplierId);
    } else {
      localStorage.removeItem('supplierId');
    }
    if (values.contractNumber) {
      localStorage.setItem('contractNumber', values.contractNumber);
    } else {
      localStorage.removeItem('contractNumber');
    }
    if (values.previousContractId) {
      localStorage.setItem('previousContractId', values.previousContractId);
    } else {
      localStorage.removeItem('previousContractId');
    }
    if (values.previousContractNumber) {
      localStorage.setItem('previousContractNumber', values.previousContractNumber);
    } else {
      localStorage.removeItem('previousContractNumber');
    }
    if (values.wizard) {
      localStorage.setItem('wizard', values.wizard);
    } else {
      localStorage.removeItem('wizard');
    }
    if (values.brokerDocuments) {
      localStorage.setItem('brokerDocuments', values.brokerDocuments);
    } else {
      localStorage.removeItem('brokerDocuments');
    }
    if (values.externalBrokerDocuments) {
      localStorage.setItem('externalBrokerDocuments', values.externalBrokerDocuments);
    } else {
      localStorage.removeItem('externalBrokerDocuments');
    }
    if (values.supplierContractEditable === true) {
      localStorage.setItem('supplierContractEditable', 'true');
    } else if (values.supplierContractEditable === false) {
      localStorage.setItem('supplierContractEditable', 'false');
    }
  }
}
